import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { GoodgovernenceService } from 'src/app/services/goodgovernence.service';
import 'dotdotdot-js'
@Component({
  selector: 'app-ethic-detail',
  templateUrl: './ethic-detail.component.html',
  styleUrls: ['./ethic-detail.component.scss']
})
export class EthicDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: GoodgovernenceService,
    private _sanitizer: DomSanitizer) { }
  language = JSON.parse(localStorage.getItem('language'))
  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';


  fundrecomm: any;
  showfundrecomm: any;
  detail: any;
  file_pdf: string;
  fundrecommTitle: string;
  fundrecommType: string;
  fundrecommDate: string;
  pdfUrl_path: any;
  pdfUrl: any;

  id: any;
  private player;
  private ytEvent;

  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.fundrecomm = this.route.params.subscribe(params => {
      this._mainService.get_ethicById(params['id']).subscribe(response => {
        
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].ethic_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail = this.htmlTransforms(response[0].detail);
            this.detail = this.htmlTransforms(response[0].detail);

            this.showfundrecomm = response;
            this.fundrecommTitle = response[0].title;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].ethic_type === 'image') {
            this.file_pdf = 'no';
            this.showfundrecomm = response;
            this.detail = response[0].detail;
            this.fundrecommTitle = response[0].title;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].ethic_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail;
            this.showfundrecomm = response;
            this.pdfUrl = this.urlTransform(response[0].detail);
            this.fundrecommTitle = response[0].title;
            this.fundrecommType = response[0].ethic_type;
            this.filesize = response[0].filesize
            this.fundrecommDate = this._mainService.date_thai(response[0].publicDate);

          }
          else if (response[0].ethic_type === 'vdo') {
            this.file_pdf = 'no';
            this.showfundrecomm = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.fundrecommTitle = response[0].title;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = this._mainService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].ethic_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);

            this.showfundrecomm = response;
            this.fundrecommTitle = response[0].title_en;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = response[0].publicDate

          } else if (response[0].ethic_type === 'image') {
            this.file_pdf = 'no';
            this.showfundrecomm = response;
            this.detail = response[0].detail_en;
            this.fundrecommTitle = response[0].title_en;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = response[0].publicDate

          } else if (response[0].ethic_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.showfundrecomm = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.fundrecommTitle = response[0].title_en;
            this.fundrecommType = response[0].ethic_type;
            this.filesize = response[0].filesize
            this.fundrecommDate = response[0].publicDate

          }
          else if (response[0].ethic_type === 'vdo') {
            this.file_pdf = 'no';
            this.showfundrecomm = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.fundrecommTitle = response[0].title_en;
            this.fundrecommType = response[0].ethic_type;
            this.fundrecommDate = response[0].publicDate

          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.fundrecomm.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}